import { WHITE_LABELED_PRODUCT_NAMES } from "config"
import { AppConfiguration } from "config"


export const generateCodeSnippet = (snippet_type, macro) => {

    if (!macro) {
        macro = '<change_me>'
    }
    switch (snippet_type) {
        case "IF_ELSE":
            //Generate if else condition
            return `{% if ${macro} %} \n <Enter Code for true condition> \n {% else %} \n <Enter Code for false condition> \n {% endif %}`
        case "FOR_LOOP":
            //Generate for loop
            return `{% for ${macro} %} \n {% endfor %}`
        case "WHILE_LOOP":
            //Generate while loop
            return `{% while ${macro} %} \n {% endwhile %}`
        case "CASE":
            //Generate case
            return `{% case ${macro} %} \n {% endcase %}`
        case "COMMENT":
            //Generate comment
            return `{% comment %} \n {% endcomment %}`
        case "RAW":
            //Generate raw
            return `{% raw %} \n {% endraw %}`
        case "INCLUDE":
            //Generate include
            return `{% include ${macro} %}`
        case "INCLUDE_WITH_VARIABLES":
            //Generate include with variables
            return `{% include ${macro} with ${macro} %}`
        case "INCLUDE_WITH_VARIABLES_AND_LOCALE":
            //Generate include with variables and locale
            return `{% include ${macro} with ${macro} locale: ${macro} %}`
        case "RANGE":
            //Generate range
            return `{% range ${macro} %} \n {% endrange %}`

            return ''

    }
}

export const LEAD_INTEGRATION_CODE_SNIPPET_TYPES = {
    IF_ELSE: "IF_ELSE",
    FOR_LOOP: "FOR_LOOP",
    WHILE_LOOP: "WHILE_LOOP",
    CASE: "CASE",
    COMMENT: "COMMENT",
    RAW: "RAW",
    INCLUDE: "INCLUDE",
    INCLUDE_WITH_VARIABLES: "INCLUDE_WITH_VARIABLES",
    INCLUDE_WITH_VARIABLES_AND_LOCALE: "INCLUDE_WITH_VARIABLES_AND_LOCALE",
    RANGE: "RANGE"
}



export const SAMPLE_LEAD_JSON_1 =
    `

{
    "version": "{{version}}",
    "client": {
        "first_name": "{{first_name}}",
        "last_name": "{{last_name}}",
        "email":"{{email}}",
        "phone": "{{phone}}"
    },
    "sales_lead": {
        "car": {
            "make": "Toyota",
            "model": "Corolla",
            "version": "VVTI",
            "year": 2006,
            "horsepower": 110,
            "url": "https://www.mydealerwebsite.com/toyota-corolla-2006-gasoline-vvti.html"
        },
        "inquiry": "Hi, is this vehicle still available?"
    }
}`

export const filterIntegrationMacros = (categories, isInternalAccount, sicTargetingFlags, isAdmin = false) => {
    return categories?.map(category => {
        const new_macros = category?.sf_lead_integration_macros.filter(macro => {
            if (ADMIN_ONLY_MACRO_KEYS.includes(macro.key) && !isAdmin && !AppConfiguration.IS_RTB_BRAND) {
                // BM-9533: AID/CID macros can only be added by admins (outside RTB)
                return false;
            }
            else if (STATE_FARM_MACRO_KEYS.includes(macro.key)) {
                return false;
            }
            else if (SYNDI_CLICK_SOURCE_TYPE_MACRO_KEY === macro.key) {
                // Syndi Click Source Type macro is enabled only for internal accounts
                return isInternalAccount;
            }
            else if (ZIP_TIER_MACRO_KEYS.includes(macro.key)) {
                // Zip tier macros are only enabled for non internal accounts on Insurance IO
                return !isInternalAccount && AppConfiguration.PRODUCT_NAME === WHITE_LABELED_PRODUCT_NAMES.INSURANCE_IO;
            }
            else if (SIC4_NAICS_MACRO_KEYS.includes(macro.key)) {
                return !!sicTargetingFlags.isEnableSicAndNaicsTargeting;
            }
            else if (SIC8_MACRO_KEY === macro.key) {
                return !!sicTargetingFlags.isEnableSicEightTargeting;
            }
            return true;
        })
        return { ...category, sf_lead_integration_macros: new_macros }
    })
}

const SYNDI_CLICK_SOURCE_TYPE_MACRO_KEY = 'syndi_click_source_type';
const STATE_FARM_MACRO_KEYS = ['subsidy', 'campaign_code', 'agent_id', 'agent_alias', 'vendor_transaction_id']
const ZIP_TIER_MACRO_KEYS = ['zip_tier_dest_url', 'zip_tier_fallback_url', 'zip_tier_tracking_params'];
const SIC4_NAICS_MACRO_KEYS = ['business_info_sic4', 'business_info_naics'];
const SIC8_MACRO_KEY = 'business_info_sic8';
// Publisher AID/CID macros. aid, cid and sid are inactive in the catalog today.
const ADMIN_ONLY_MACRO_KEYS = ['source', 'sub_source', 'pub_aid', 'pub_cid', 'aid', 'cid', 'sid'];
